import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
// import { Collapse } from 'components';
import {
  device,
  PrimaryButtonV2,
  YouTubeModal,
  // SvgWrapper
} from 'utils';
import {
  AlhamdulillahCalligraphy,
  AllahummaCalligraphy,
  BismillahCalligraphy,
  EditNavPattern,
  EditStepDone,
  NavConnectorActive,
  NavConnectorInactive,
  NavStepDoing,
  NavStepDone,
  NavStepTodo,
  SidebarPattern,
  TreeImage,
} from 'images';
import { Link } from 'react-router-dom';

const SideBarWrapper = styled.aside`
  position: relative;
  height: 100%;
  direction: rtl;
  * {
    direction: ltr;
  }
  @media ${device.maxLaptop} {
    max-height: 210px;
    overflow: hidden;
    direction: ltr;
  }
`;

const NavigationWrapper = styled.nav`
  padding: 64px;
  width: 560px;
  position: relative;
  height: 100%;
  @media ${device.maxLaptop} {
    width: 100%;
    padding: 32px;
  }
`;

const NavContentWrapper = styled.nav`
  position: relative;
  z-index: 1;
  @media ${device.maxLaptop} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const BackgroundWrapper = styled.div`
  background: #e6f4d7;
  height: 100%;
  borderright: '4px solid #4a9af1';
`;

const BackgroundImage = styled.div`
  display: none;
  position: absolute;
  left: -176px;
  top: -100px;
  width: 352px;
  height: 352px;
  background: url(${TreeImage}) no-repeat left center;
  background-size: contain;
  opacity: 0.5;
  z-index: 0;
  pointer-events: none;
  clip-path: inset(100px 0 42px 0);
  @media ${device.maxLaptop} {
    display: block;
  }
`;

const WelcomeScreen = styled.div`
  display: flex;
  flex-direction: column;
  color: #4a5724;
  @media ${device.maxLaptop} {
    justify-content: center;
    align-items: center;
  }
`;

const WelcomeTitle = styled.h1`
  color: #2b4212;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
  @media ${device.maxLaptop} {
    font-size: 16px;
    margin-bottom: 16px;
    text-align: center;
  }
`;

const WelcomeSubtitle = styled.h1`
  color: #2b4212;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 24px;
  @media ${device.maxLaptop} {
    font-size: 16px;
    margin-bottom: 4px;
    text-align: center;
  }
`;

const WelcomeText = styled.p`
  font-size: 1.25rem;
  color: #535862;
  margin-bottom: 2rem;
  @media ${device.maxLaptop} {
    font-size: 14px;
    margin-bottom: 14px;
    text-align: center;
  }
`;

const Quote = styled.blockquote`
  @media ${device.maxLaptop} {
    display: none;
  }
  color: #535862;
  font-size: 16px;
`;

const QuoteAttribution = styled.p`
  @media ${device.maxLaptop} {
    display: none;
  }
  font-size: 14px;
  margin-top: 8px;
`;

const NavGap = styled.p`
  height: 32px;
`;

const TreeWrapper = styled.p`
  z-index: 1;
  position: relative;
  left: 64px;
  bottom: 448px;
  max-width: 432px;
  @media ${device.maxLaptop} {
    display: none;
  }
`;

const CalligraphyWrapper = styled.p`
  * {
    max-height: 40px;
    @media ${device.maxLaptop} {
      max-height: 30px;
    }
  }
`;

const PatternWrapper = styled.p`
  position: absolute;
  left: -12px;
  top: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
  height: 100%;
  @media ${device.maxLaptop} {
    display: none;
  }
`;

const MobileNavigationWrapper = styled.p`
  padding: 16px;
  margin: 0;
  position: relative;
  height: 100%;
  width: 100%;
  max-height: 210px;
  overflow: hidden;
  direction: ltr;
`;

class SideBar extends Component {
  static propTypes = {
    handelCurrentView: PropTypes.func.isRequired,
    currentView: PropTypes.number.isRequired,
    projectId: PropTypes.string,
    project: PropTypes.object.isRequired,
    isStripeDone: PropTypes.bool.isRequired,
    canMove: PropTypes.bool.isRequired,
    handelShowModal: PropTypes.func.isRequired,
    setSelectedStep: PropTypes.func.isRequired,
    getPayPalStatus: PropTypes.bool.isRequired,
    mobileFormShow: PropTypes.bool.isRequired,
    editProject: PropTypes.bool.isRequired,
  };
  state = {
    isAnyStepSelected: false,
    isShow: false,
    goodiesOpened: false,
    showVideoModal: false,
  };

  componentDidMount() {
    this.props.setSelectedStep(7);
    let payPalStatus = window.location.href.includes('merchantId');
    if (payPalStatus) {
      this.props.setSelectedStep(8);
      this.props.handelCurrentView(8);
    }
    const { isStripeDone, setSelectedStep } = this.props;
    if (isStripeDone) {
      setSelectedStep(8);
    }
  }

  sideBarTitle = () => {
    const { currentView, mobileFormShow } = this.props;
    const username = JSON.parse(localStorage.getItem('user'))?.first_name;

    switch (currentView) {
      case 1:
        return (
          <>
            <CalligraphyWrapper>
              <img src={BismillahCalligraphy} alt="Bismillah calligraphy" />
            </CalligraphyWrapper>
            <WelcomeTitle>
              Bismillahi ar-Rahmani ar-Rahim.
              <br />
              Lass uns loslegen.
            </WelcomeTitle>
          </>
        );
      case 2:
        return (
          <>
            <CalligraphyWrapper>
              <img
                src={AlhamdulillahCalligraphy}
                alt="Alhamdulillah calligraphy"
              />
            </CalligraphyWrapper>
            <WelcomeTitle style={{ marginBottom: '0' }}>
              Alhamdulillah rabbil 'alamin.
            </WelcomeTitle>
          </>
        );
      case 3:
        return (
          <>
            <CalligraphyWrapper>
              <img src={AllahummaCalligraphy} alt="Allahumma calligraphy" />
            </CalligraphyWrapper>
            <WelcomeTitle style={{ marginBottom: '0' }}>
              Allahumma salli 'ala Muhammad wa 'ala ali Muhammad.
            </WelcomeTitle>
          </>
        );
      case 6:
        return (
          <>
            {mobileFormShow && (
              <CalligraphyWrapper>
                <img src={BismillahCalligraphy} alt="Bismillah calligraphy" />
              </CalligraphyWrapper>
            )}
            <WelcomeTitle>Mach dein Projekt sichtbar.</WelcomeTitle>
          </>
        );
      case 7:
        return (
          <>
            {mobileFormShow && (
              <CalligraphyWrapper>
                <img src={BismillahCalligraphy} alt="Bismillah calligraphy" />
              </CalligraphyWrapper>
            )}
            <WelcomeTitle>
              Biete deiner Community eine
              <br />
              Gegenleistung.
            </WelcomeTitle>
          </>
        );
      case 8:
      case 9:
        return (
          <>
            {mobileFormShow && (
              <CalligraphyWrapper>
                <img src={BismillahCalligraphy} alt="Bismillah calligraphy" />
              </CalligraphyWrapper>
            )}
            <WelcomeTitle>Wir sind gleich soweit.</WelcomeTitle>
          </>
        );

      default:
        return (
          <>
            {mobileFormShow && (
              <CalligraphyWrapper>
                <img src={BismillahCalligraphy} alt="Bismillah calligraphy" />
              </CalligraphyWrapper>
            )}
            <WelcomeTitle>
              Salam, {username ? username : 'User'}.
              <br />
              Erzähle uns mehr über dein Projekt.
            </WelcomeTitle>
          </>
        );
    }
  };

  isWelcomePage = () => {
    const { currentView } = this.props;
    return currentView === 1 || currentView === 2 || currentView === 3;
  };

  renderWelcomeScreen = () => {
    return (
      <WelcomeScreen>
        <NavContentWrapper>
          {this.sideBarTitle()}
          <WelcomeText>
            Falls Du Hilfe brauchst oder Fragen hast,
            <br />
            schau dir gerne{' '}
            <a
              onClick={this.handleShowVideo}
              style={{
                color: '#4a5724',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              unser Erklärvideo
            </a>{' '}
            an.
          </WelcomeText>
          <Quote>
            "Gewiss, die (Gültigkeit der) Taten hängt von den Absichten ab, und
            jeder Mensch bekommt das, was er beabsichtigt hat."
            <QuoteAttribution>
              — sinngemäß Sayyiduna Muhammad ﷺ
            </QuoteAttribution>
          </Quote>
        </NavContentWrapper>

        <PatternWrapper>
          <div>
            <img src={SidebarPattern} alt="Pattern" />
          </div>
        </PatternWrapper>
        <NavGap />
      </WelcomeScreen>
    );
  };

  // Group the steps into categories to match the new design
  getSteps = () => {
    const { currentView, projectId, project } = this.props;

    const {
      basicInfo,
      projectDescription,
      media,
      contractDocuments,
      isGoodiesDone,
    } = project;

    const { goodiesOpened } = this.state;

    if (
      !goodiesOpened &&
      (currentView === 8 || currentView === 9 || isGoodiesDone)
    )
      this.setState({ goodiesOpened: true });
    return [
      {
        id: 1,
        title: 'Dein Projekt',
        description: 'Erzähle uns mehr über dein Projekt.',
        isActive: currentView === 4,
        isCompleted: basicInfo?.isDone && projectId,
        subSteps: [
          {
            id: 4,
            title: 'Grundlegendes',
            isActive: currentView === 4,
            isCompleted: basicInfo?.isDone && projectId,
          },
        ],
      },
      {
        id: 2,
        title: 'Zusätzliche Angaben',
        description: 'Beantworte häufig gestellte Fragen.',
        isActive: currentView === 5,
        isCompleted: projectDescription?.isDone && projectId,
        subSteps: [
          {
            id: 5,
            title: 'Projektinformationen',
            isActive: currentView === 5,
            isCompleted: projectDescription?.isDone && projectId,
          },
        ],
      },
      {
        id: 3,
        title: 'Medien',
        description: 'Lade Bilder oder ein Video hoch.',
        isActive: currentView === 6,
        isCompleted: media?.isDone && projectId,
        subSteps: [
          {
            id: 6,
            title: 'Bilder und Videos',
            isActive: currentView === 6,
            isCompleted: media?.isDone && projectId,
          },
        ],
      },
      {
        id: 4,
        title: 'Goodies',
        description: 'Biete deiner Community eine Gegenleistung.',
        isActive: currentView === 7,
        isCompleted: (goodiesOpened || isGoodiesDone) && projectId,
        subSteps: [
          {
            id: 7,
            title: 'Goodies',
            isActive: currentView === 7,
            isCompleted: (goodiesOpened || isGoodiesDone) && projectId,
          },
        ],
      },
      {
        id: 5,
        title: 'Einreichung & Zahlungsabwicklung',
        description: 'Der letzte Schritt, bevor es losgeht!',
        isActive: currentView === 8 || currentView === 9,
        isCompleted: false,
        subSteps: [
          {
            id: 8,
            title: 'Dokumente',
            isActive: currentView === 8,
            isCompleted: false,
          },
          {
            id: 9,
            title: 'Einreichung',
            isActive: currentView === 9,
            isCompleted: contractDocuments?.isDone && projectId,
          },
        ],
      },
    ];
  };

  getEditSteps = () => {
    const { currentView, projectId, project } = this.props;

    const {
      basicInfo,
      projectDescription,
      media,
      contractDocuments,
      fundingTarget,
      stripeStatus,
      isGoodiesDone,
    } = project;

    const { goodiesOpened } = this.state;

    if (!goodiesOpened && (currentView === 7 || isGoodiesDone))
      this.setState({ goodiesOpened: true });
    return [
      {
        id: 1,
        title: 'Grundlegendes',
        isActive: currentView === 1,
        isCompleted: true,
        subSteps: [
          {
            id: 1,
            title: 'Grundlegendes',
            isActive: currentView === 1,
            isCompleted: true,
          },
        ],
      },
      {
        id: 2,
        title: 'Projektbeschreibung',
        isActive: currentView === 2,
        isCompleted: basicInfo?.isDone && projectId,
        subSteps: [
          {
            id: 2,
            title: 'Projektbeschreibung',
            isActive: currentView === 2,
            isCompleted: basicInfo?.isDone && projectId,
          },
        ],
      },
      {
        id: 3,
        title: 'Zusätzliche Angaben',
        isActive: currentView === 3,
        isCompleted: projectDescription?.isDone && projectId,
        subSteps: [
          {
            id: 3,
            title: 'Zusätzliche Angaben',
            isActive: currentView === 3,
            isCompleted: projectDescription?.isDone && projectId,
          },
        ],
      },
      {
        id: 4,
        title: 'Fundingziel',
        isActive: currentView === 4,
        isCompleted: fundingTarget?.isDone && projectId,
        subSteps: [
          {
            id: 4,
            title: 'Fundingziel',
            isActive: currentView === 4,
            isCompleted: fundingTarget?.isDone && projectId,
          },
        ],
      },
      {
        id: 5,
        title: 'Medien',
        isActive: currentView === 5,
        isCompleted: media?.isDone && projectId,
        subSteps: [
          {
            id: 5,
            title: 'Medien',
            isActive: currentView === 5,
            isCompleted: media?.isDone && projectId,
          },
        ],
      },
      {
        id: 6,
        title: 'Goodies',
        isActive: currentView === 6,
        isCompleted: true,
        subSteps: [
          {
            id: 6,
            title: 'Goodies',
            isActive: currentView === 6,
            isCompleted: true,
          },
        ],
      },
      {
        id: 7,
        title: 'Legitimation',
        isActive: currentView === 7,
        isCompleted:
          (stripeStatus === 'enabled_and_eventually_due' ||
            stripeStatus === 'enabled') &&
          projectId,
        subSteps: [
          {
            id: 7,
            title: 'Legitimation',
            isActive: currentView === 7,
            isCompleted:
              (stripeStatus === 'enabled_and_eventually_due' ||
                stripeStatus === 'enabled') &&
              projectId,
          },
        ],
      },
      {
        id: 8,
        title: 'Einreichung',
        isActive: currentView === 8,
        isCompleted: contractDocuments?.isDone && projectId,
        subSteps: [
          {
            id: 8,
            title: 'Einreichung',
            isActive: currentView === 8,
            isCompleted: contractDocuments?.isDone && projectId,
          },
        ],
      },
    ];
  };

  handleStepClick = (stepId) => {
    const {
      handelCurrentView,
      projectId,
      canMove,
      handelShowModal,
      setSelectedStep,
    } = this.props;

    const steps = this.getSteps();

    const findStepById = (id) => {
      for (const step of steps) {
        if (step.id === id) return step.isCompleted;
      }
      return false;
    };

    if (stepId === 4 || findStepById(stepId - 4)) {
      setSelectedStep(projectId && stepId);
      //if (canMove) {
      handelCurrentView(stepId);
      //} else {
      //  handelShowModal();
      //}
    }
  };

  handleEditStepClick = (stepId) => {
    const {
      handelCurrentView,
      projectId,
      canMove,
      handelShowModal,
      setSelectedStep,
    } = this.props;

    setSelectedStep(projectId && stepId);
    //if (canMove) {
    handelCurrentView(stepId);
    //} else {
    //  handelShowModal();
    //}
  };

  handleShowVideo = () => this.setState({ showVideoModal: true });
  handleHideVideo = () => this.setState({ showVideoModal: false });

  renderNavigationSteps() {
    const { mobileFormShow } = this.props;

    const steps = this.getSteps();

    return (
      <>
        <NavContentWrapper>
          {/* Welcome section */}
          {mobileFormShow ? (
            this.renderWelcomeScreen()
          ) : (
            <div style={{ marginBottom: '3rem' }}>
              <h1
                style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#2B4212',
                }}
              >
                {this.sideBarTitle()}
              </h1>

              <p
                style={{
                  fontSize: '20px',
                  fontWeight: '400',
                  color: '#535862',
                }}
              >
                Falls Du Hilfe brauchst oder Fragen hast,
                <br />
                schau dir gerne{' '}
                <a
                  onClick={this.handleShowVideo}
                  style={{
                    color: '#3F621A',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontWeight: '400',
                  }}
                >
                  unser Erklärvideo
                </a>{' '}
                an.
              </p>
            </div>
          )}

          {/* New stepper navigation */}
          {!mobileFormShow && (
            <div style={{ flex: 1 }}>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                {steps.map((step) => (
                  <li
                    key={step.id}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px',
                      position: 'relative',
                    }}
                  >
                    {step.id < steps.length && (
                      <div
                        style={{
                          position: 'absolute',
                          left: '12px',
                          top: '29px',
                          width: '2px',
                          height: '34px',
                          transform: 'translateX(-50%)',
                        }}
                      >
                        {steps[step.id].isActive ||
                        steps[step.id].isCompleted ? (
                          <img
                            src={NavConnectorActive}
                            alt="Navigation connection active"
                          />
                        ) : (
                          <img
                            src={NavConnectorInactive}
                            alt="Navigation connection inactive"
                          />
                        )}
                      </div>
                    )}

                    {/* Circle indicator */}
                    <div
                      onClick={() => this.handleStepClick(step.subSteps[0].id)}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      {step.isActive ? (
                        <div
                          style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            marginLeft: '-3px',
                            marginTop: '-3px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <img src={NavStepDoing} alt="Navigation step doing" />
                        </div>
                      ) : step.isCompleted ? (
                        <div
                          style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <img src={NavStepDone} alt="Navigation step done" />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                          }}
                        >
                          <img
                            style={{ paddingBottom: '10px' }}
                            src={NavStepTodo}
                            alt="Navigation step todo"
                          />
                        </div>
                      )}
                    </div>

                    {/* Step content */}
                    <div style={{ flex: 1 }}>
                      <div
                        onClick={() =>
                          this.handleStepClick(step.subSteps[0].id)
                        }
                        style={{
                          fontWeight: '600',
                          fontSize: '14px',
                          color: step.isActive ? '#3F621A' : '#414651',
                          marginBottom: '0.25rem',
                          cursor: 'pointer',
                        }}
                      >
                        {step.title}
                      </div>
                      <div
                        style={{
                          fontSize: '14px',
                          color: step.isActive ? '#3F621A' : '#535862',
                          marginBottom: '0.5rem',
                        }}
                      >
                        {step.description}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </NavContentWrapper>

        <NavGap />
        <PatternWrapper>
          <div
            style={{
              marginTop: '184px',
            }}
          >
            <img src={SidebarPattern} alt="Pattern" />
          </div>
        </PatternWrapper>
      </>
    );
  }

  renderMobileNavigation() {
    const steps = this.getSteps();

    return (
      <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'row',
            gap: '32px',
          }}
        >
          {steps.map((step) => (
            <li
              key={step.id}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                gap: '12px',
                position: 'relative',
              }}
            >
              {step.id < steps.length && (
                <div
                  style={{
                    position: 'absolute',
                    left: '41px',
                    top: '20px',
                    width: '2px',
                    height: '48px',
                    transform: 'translateY(-50%)',
                  }}
                >
                  {steps[step.id].isActive || steps[step.id].isCompleted ? (
                    <img
                      src={NavConnectorActive}
                      alt="Navigation connection active"
                      style={{ transform: 'rotate(90deg)' }}
                    />
                  ) : (
                    <img
                      src={NavConnectorInactive}
                      alt="Navigation connection inactive"
                      style={{ transform: 'rotate(90deg)' }}
                    />
                  )}
                </div>
              )}

              {/* Circle indicator */}
              <div
                onClick={() => this.handleStepClick(step.subSteps[0].id)}
                style={{
                  cursor: 'pointer',
                }}
              >
                {step.isActive ? (
                  <div
                    style={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      marginLeft: '-2px',
                      marginTop: '-2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={NavStepDoing} alt="Navigation step doing" />
                  </div>
                ) : step.isCompleted ? (
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={NavStepDone} alt="Navigation step done" />
                  </div>
                ) : (
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                    }}
                  >
                    <img src={NavStepTodo} alt="Navigation step todo" />
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  displayPreview = () => {};

  renderEditSteps() {
    const { mobileFormShow, projectId } = this.props;

    const steps = this.getEditSteps();

    return (
      <>
        <NavContentWrapper>
          {/* Welcome section */}
          {mobileFormShow ? (
            this.renderWelcomeScreen()
          ) : (
            <div style={{ marginBottom: '3rem' }}>
              <h1
                style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#181D27',
                }}
              >
                Projekt bearbeiten
              </h1>
            </div>
          )}

          {/* New stepper navigation */}
          {!mobileFormShow && (
            <div style={{ flex: 1 }}>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                {steps.map((step) => (
                  <li
                    key={step.id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      position: 'relative',
                      height: '44px',
                    }}
                  >
                    {/* Circle indicator */}
                    <div
                      onClick={() =>
                        this.handleEditStepClick(step.subSteps[0].id)
                      }
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      {step.isActive ? (
                        <div style={{ flex: 1 }}>
                          <div
                            onClick={() =>
                              this.handleEditStepClick(step.subSteps[0].id)
                            }
                            style={{
                              fontWeight: '600',
                              fontSize: '16px',
                              color: '#3F621A',
                              cursor: 'pointer',
                              width: 'auto',
                              height: '44px',
                              alignContent: 'center',
                              paddingLeft: '12px',
                              borderLeft: '2px solid #9DBC60',
                            }}
                          >
                            {step.title}
                          </div>
                        </div>
                      ) : (
                        <div style={{ flex: 1 }}>
                          <div
                            onClick={() =>
                              this.handleEditStepClick(step.subSteps[0].id)
                            }
                            style={{
                              fontWeight: '600',
                              fontSize: '16px',
                              color: '#717680',
                              cursor: 'pointer',
                              width: 'auto',
                              height: '44px',
                              alignContent: 'center',
                              paddingLeft: '12px',
                              marginLeft: '2px',
                            }}
                          >
                            {step.title}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Step content */}

                    {step.isCompleted && (
                      <div
                        style={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <img src={EditStepDone} alt="Navigation step done" />
                      </div>
                    )}
                  </li>
                ))}
              </ul>
              <PrimaryButtonV2
                primary={true}
                minWidth="160px"
                style={{ marginTop: '24px', color: '#414651' }}
              >
                <Link to={`/view/${projectId}`}>Projektvorschau</Link>
              </PrimaryButtonV2>
            </div>
          )}
        </NavContentWrapper>

        <PatternWrapper>
          <div>
            <img src={EditNavPattern} alt="Pattern" />
          </div>
        </PatternWrapper>
      </>
    );
  }

  renderEditMobileNavigation() {
    const steps = this.getEditSteps();

    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'flex-start',
          overflowX: 'auto',
          overflowY: 'hidden',
          WebkitOverflowScrolling: 'touch',
          padding: '16px',
        }}
      >
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'row',
            gap: '32px',
            whiteSpace: 'nowrap',
          }}
        >
          {steps.map((step) => (
            <li
              key={step.id}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                gap: '12px',
                position: 'relative',
              }}
            >
              {step.id < steps.length && (
                <div
                  style={{
                    position: 'absolute',
                    left: '41px',
                    top: '20px',
                    width: '2px',
                    height: '48px',
                    transform: 'translateY(-50%)',
                  }}
                >
                  {steps[step.id].isActive || steps[step.id].isCompleted ? (
                    <img
                      src={NavConnectorActive}
                      alt="Navigation connection active"
                      style={{ transform: 'rotate(90deg)' }}
                    />
                  ) : (
                    <img
                      src={NavConnectorInactive}
                      alt="Navigation connection inactive"
                      style={{ transform: 'rotate(90deg)' }}
                    />
                  )}
                </div>
              )}

              {/* Circle indicator */}
              <div
                onClick={() => this.handleEditStepClick(step.subSteps[0].id)}
                style={{
                  cursor: 'pointer',
                }}
              >
                {step.isActive ? (
                  <div
                    style={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      marginLeft: '-2px',
                      marginTop: '-2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={NavStepDoing} alt="Navigation step doing" />
                  </div>
                ) : step.isCompleted ? (
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={NavStepDone} alt="Navigation step done" />
                  </div>
                ) : (
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                    }}
                  >
                    <img src={NavStepTodo} alt="Navigation step todo" />
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  render() {
    const { mobileFormShow, editProject } = this.props;
    const { showVideoModal } = this.state;
    return (
      <>
        <BackgroundWrapper>
          <BackgroundImage />
          <SideBarWrapper>
            <NavigationWrapper>
              {editProject
                ? this.renderEditSteps()
                : this.isWelcomePage()
                ? this.renderWelcomeScreen()
                : this.renderNavigationSteps()}
              {/*this.renderEditSteps()*/}
              {/*this.isWelcomePage() ? this.renderWelcomeScreen() : this.renderNavigationSteps()*/}
            </NavigationWrapper>
            <YouTubeModal
              link="https://www.youtube.com/embed/JyfjVfbUs9E"
              showModal={showVideoModal}
              closeModal={this.handleHideVideo}
            />
          </SideBarWrapper>
          {!editProject && (
            <TreeWrapper>
              <div
                style={{
                  marginTop: 'auto',
                  textAlign: 'center',
                  padding: '0',
                }}
              >
                <img
                  src={TreeImage || '/placeholder.svg'}
                  alt="Tree illustration"
                />
              </div>
            </TreeWrapper>
          )}
        </BackgroundWrapper>
        {mobileFormShow && (
          <>
            {editProject ? (
              this.renderEditMobileNavigation()
            ) : (
              <>
                {!this.isWelcomePage() && (
                  <MobileNavigationWrapper>
                    {this.renderMobileNavigation()}
                  </MobileNavigationWrapper>
                )}
              </>
            )}
          </>
        )}
        {/*mobileFormShow && (
          <MobileNavigationWrapper>
            {this.renderEditMobileNavigation()}
          </MobileNavigationWrapper>
        )*/}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, errors } = state.projects;
  return {
    project,
    loading,
    errors,
  };
};

export default connect(mapStateToProps)(SideBar);
